import PageShell from "../../../layout/PageShell";
import useAccountId, {
  useBreadcrumbsWithCustomDomain,
} from "../../../hooks/customDomainHooks";
import EmployeeTurnoverReport from "./EmployeeTurnoverReport";

const EmployeeTurnoverReportPage = () => {
  const { accountId } = useAccountId();
  const breadcrumbs = useBreadcrumbsWithCustomDomain([
    { type: "HOME", href: `/${accountId}/home` },
    { name: "Reports", href: `/${accountId}/reports` },
    { name: "Employee Turnover" },
  ]);

  return (
    <PageShell breadcrumbs={breadcrumbs}>
      <EmployeeTurnoverReport />
    </PageShell>
  );
};

export default EmployeeTurnoverReportPage;
